import {
  ButtonsContainer,
  PartialSanityImageType,
  ResponsiveSanityImage,
  SectionContainer
} from "@silversea-ssc/ui-components-react";
import PageBuilderButtonCTA, {
  PageBuilderButtonCTAProps
} from "components/PageBuilder/PageBuilderButtonCTA";
import React from "react";
import * as styles from "./BoxedOpeningHero.module.scss";

type Props = {
  title?: string;
  image?: PartialSanityImageType;
  subtitle?: string;
  ctaButtons?: PageBuilderButtonCTAProps[];
};

const BoxedOpeningHero: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  subtitle,
  image,
  ctaButtons
}) => {
  return (
    <div id="hero" className={styles.box} data-content-name="hero">
      {image && (
        <ResponsiveSanityImage
          image={image}
          className={styles.backgroundImage}
          defaultWidth={3000}
          defaultHeight={675}
          alt={title}
        />
      )}
      <div className={styles.contentBox}>
        <SectionContainer backgroundColor="transparent">
          <div className={styles.content}>
            <header className={styles.header}>
              <h2 className={styles.title}>{title}</h2>
              <h3 className={styles.subtitle}>{subtitle}</h3>
            </header>
            {ctaButtons && (
              <footer className={styles.contentBoxFooter}>
                <ButtonsContainer align="center" mobileFullSize>
                  {ctaButtons.map((b) => (
                    <PageBuilderButtonCTA
                      key={b?._key}
                      forHero="normal"
                      {...b}
                    />
                  ))}
                </ButtonsContainer>
              </footer>
            )}
          </div>
        </SectionContainer>
      </div>
    </div>
  );
};

export default BoxedOpeningHero;
